// extracted by mini-css-extract-plugin
module.exports = {"primarytheme":"--primary-theme"};